import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { isNotNullish } from '@y42/util/nullish';
import { FaIcon, Icon, ImgIcon, isFaIcon, isImgIcon, isSvgIcon, SvgIcon } from '../icon.model';

export type TStyles = Record<string, unknown>;

@Component({
  selector: 'y42-icon[icon]',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent implements OnChanges {
  @Input()
  icon?: Icon;

  @Input()
  size?: number | string;

  @Input()
  viewBox?: string;

  @Input()
  iconStyle?: TStyles;

  @Input()
  faPrefix: IconPrefix = 'fal';

  @Input()
  alt?: string;

  /**
   * Override to render `.svg` icons using the `<img src="" />` element
   */
  @Input() renderSvgAsImg = false;

  protected svgIcon?: SvgIcon;
  protected imgIcon?: ImgIcon;
  protected faIcon?: FaIcon;
  protected extendedIconStyle: TStyles = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icon']) {
      this.setIcon(this.icon);
    }

    if (changes['iconStyle'] || changes['size']) {
      this.setIconStyle(this.iconStyle, this.size);
    }
  }

  private setIcon(icon?: Icon): void {
    this.svgIcon = undefined;
    this.imgIcon = undefined;
    this.faIcon = undefined;

    if (!icon) {
      return;
    }

    if (isSvgIcon(icon) && !this.renderSvgAsImg) {
      this.svgIcon = icon;
    } else if (isImgIcon(icon) || (isSvgIcon(icon) && this.renderSvgAsImg)) {
      this.imgIcon = icon as ImgIcon;
    } else if (isFaIcon(icon)) {
      this.faIcon = icon;
    }
  }

  private setIconStyle(iconStyle?: TStyles, size?: number | string): void {
    const extendedIconStyle: TStyles = { ...iconStyle };

    if (isNotNullish(size)) {
      extendedIconStyle['width.px'] = size;
    }

    this.extendedIconStyle = extendedIconStyle;
  }
}
